module.exports = __webpack_public_path__ + "img/fish6.e7cba898.png";